export function normalizePhoneInput(value) {
  return String(value ?? "").trim();
}

export function compactPhone(value) {
  return normalizePhoneInput(value).replace(/[\s\-().]/g, "");
}

export function phoneHasCountryCode(value) {
  const compact = compactPhone(value);
  return /^\+[1-9]\d{7,14}$/.test(compact);
}

export function validatePhoneWithCountryCode(value, { required = false } = {}) {
  const raw = normalizePhoneInput(value);
  if (!raw) {
    return required
      ? { ok: false, message: "Please enter a phone number with country code (e.g. +91 88742 00200)." }
      : { ok: true };
  }
  if (!raw.startsWith("+")) {
    return {
      ok: false,
      message: "Phone number must start with a country code and + sign (e.g. +91, +971, +44).",
    };
  }
  if (!phoneHasCountryCode(raw)) {
    return {
      ok: false,
      message: "Please enter a valid phone number with country code (e.g. +91 88742 00200).",
    };
  }
  return { ok: true, value: raw };
}

export function showPhoneValidationError(message, toast) {
  toast.error(message);
}
